import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-success-dialog-window',
  templateUrl: './success-dialog-window.component.html',
  styleUrls: ['./success-dialog-window.component.scss'],
})
export class SuccessDialogWindowComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SuccessDialogWindowComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {}

  onClose(): void {
    this.dialogRef.close();
  }
}
